import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer";
import userReducer from "./reducers/userReducer";
import reportReducer from "./reducers/reportReducer";
import subscriptionReducer from "./reducers/subscriptionReducer";
import groupReducer from "./reducers/subscriptionReducer";
import groupReportReducer from "./reducers/groupReportReducer";

const store = configureStore({
  reducer: {
    authReducer,
    userReducer,
    reportReducer,
    subscriptionReducer,
    groupReducer,
    groupReportReducer,
  },
});

export default store;
